import numeral from 'numeral'
import React, { useEffect, useState } from 'react'
import { Menu, Icon, Segment, Dropdown, Accordion, Form } from 'semantic-ui-react'
import { MonedaDetalleRender } from '../Pages/MonedaDetalle'
import {
    Chart, Coordinate, Axis, Tooltip, Interaction, Interval
} from 'bizcharts';
import {
    InicioMobileAsync,
    ObtenerEstatusCuentaAsync,
    ObtenerHistorialAsync,
    OrdenesActivasAsync,

} from '../Servicios/ServiciosPublicos'
import moment from 'moment';
import { SalirApp, ShowBusy } from '../Reducers/InicioReducer';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RowRender } from '../Controles/RowRender'
import { MonedasRender } from '../Pages/Monedas'
import { PrincipalDesktop } from '../Pages/PrincipalDesktop';
import { PrincipalMobile } from '../Pages/PrincipalMobile';

export const Principal = () => {
    //#region Hooks
    const dispatch = useDispatch();
    //#endregion
    //#region internalState
    const [internalState, setInternalState] = useState({
        Libros: [],
        Balance: [],
        PorCompra: 10,
        PorVenta: 10,
        BalanceG: [],
        ActiveIndex: 0,
        CongifIndex: 0,
        BalanceTotal: 0,
        InicioMobile: {
            Saldo: 0,
            Detalle: []
        },
        Cliente: {
            client_id: 0
        },
        MonedaDetalle: null,
        MonedaDetalleDetalle: [],
        MonedaDetallePrecioActual: 0,
        MonedaDetalleIndex: 0,
        MonedaDetalleInversion: 0,
        OrdenesActivas: []
    })
    //#endregion
    //#region UseEffects
    useEffect(() => { Load(); }, [])
    useEffect(() => { CalcularImporteMXN(); }, [internalState.Libros])
    //#endregion
    //#region Metodos    
    const Load = async () => { }
    const IniciarSockets = () => {
        let websocket = new WebSocket('wss://ws.bitso.com');
        websocket.onopen = function () {
            websocket.send(JSON.stringify({ action: 'subscribe', book: 'btc_mxn', type: 'trades' }));
            websocket.send(JSON.stringify({ action: 'subscribe', book: 'btc_mxn', type: 'diff-orders' }));
            websocket.send(JSON.stringify({ action: 'subscribe', book: 'btc_mxn', type: 'orders' }));
        };
        websocket.onmessage = function (message) {
            var data = JSON.parse(message.data);
            console.log(data)
        }
    }
    const CalcularImporteMXN = () => {
        if (internalState.Libros && internalState.Balance) {
            if (internalState.Libros.length > 0 && internalState.Balance.length > 0) {
                let _balance = internalState.Balance;
                let _libros = internalState.Libros;
                let _balanceG = [];
                let _importeMXN = 0;
                for (let i = 0; i < _balance.length; i++) {
                    const _moneda = _balance[i];
                    _moneda.ImporteMXN = 0;
                    if (_moneda.currency === "mxn") {
                        _moneda.ImporteMXN = _moneda.total;

                    }
                    for (let ii = 0; ii < _libros.length; ii++) {
                        const _libro = _libros[ii];
                        if (_moneda.currency === _libro.book.replace("_mxn", "")) {
                            _moneda.ImporteMXN = +_moneda.total * +_libro.last;
                        }
                    }
                    _importeMXN += +_moneda.ImporteMXN;
                    _balanceG = [..._balanceG, { Moneda: _moneda.currency, Importe: +_moneda.ImporteMXN }]
                }
                // _balanceG = [..._balanceG, { Moneda: "Total", Importe: +_importeMXN }]

                setInternalState((state) => ({ ...state, Balance: _balance, BalanceG: _balanceG, BalanceTotal: _importeMXN }));
            }
        }

    }
    const ClickAccordionConfig = (e, titleProps) => {
        const { index } = titleProps
        const { CongifIndex } = internalState
        const newIndex = CongifIndex === index ? -1 : index
        setInternalState((state) => ({ ...state, CongifIndex: newIndex }));
    }
    const OnMonedaDetalleChange = (item) => {
        setInternalState((state) => ({ ...state, MonedaDetalle: item }));
    }
    //#endregion
    //#region Renders
    let _ultimosRender = "Ultimos Precios..."
    if (internalState.Libros.length > 0) {
        _ultimosRender = `${internalState.Libros[0].book.replace("_mxn", "")}: ${numeral(+internalState.Libros[0].last).format("0,000.00")}`

    }
    //#endregion

    return (
        <div>
            <PrincipalDesktop />
            <PrincipalMobile />
        </div >
    )
}
